export default (http) => {
    return {
        queryByPage (data){
            return http.json({
                url: '/knowledge/database/query',
                data
            })
        },

        list (data){
            return http.json({
                url: '/knowledge/database/list',
                data
            })
        },
        /**
         * 保存信息
         * @param data
         * @returns {*}
         */
        save(data) {
            return http.json({
                url: '/knowledge/database/save',
                data
            })
        },
        /**
         * 获取详情
         * @param data
         * @return {*}
         */
        getInfo(data) {
            return http.json({
                url: `/knowledge/database/get?id=${data.id}`
            })
        },
        /**
         * 删除
         * @param data
         * @returns {*}
         */
        remove(data) {
            return http.json({
                url: `/knowledge/database/delete?id=${data[0].id}`,
                data
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/knowledge.js